import style from './Button.module.scss';

function Button({ className, onClick, disabled, children, icon, href, openInNewTab = true }) {
    const handleClick = (e) => {
        if (href) {
            openInNewTab ? window.open(href, '_blank') : window.location.href = href;
        }
        if (onClick) {
            onClick(e);
        }
    };

    return (
        <button
            className={[style.button, style.gradien, className].join(' ').trim()}
            onClick={handleClick}
            disabled={disabled}
        >
            {icon}
            {children}
        </button>
    );
}

export function UnderlineButton({ className, onClick, disabled, children, icon, href }) {
    const handleClick = (e) => {
        if (href) {
            window.open(href, '_blank');
            e.preventDefault();
        }
        if (onClick) {
            onClick(e);
        }
    };

    return (
        <button
            className={[style.button, style.underline, className].join(' ').trim()}
            onClick={handleClick}
            disabled={disabled}
        >
            {icon}
            {children}
        </button>
    );
}
export default Button;
